import React, { useState, useEffect, useRef } from "react";
import smoothscroll from "smoothscroll-polyfill";
// store utils
import { useStore } from "outstated";
import { AppStore } from "pages/_app";
// next util
import { useRouter } from "next/router";
// lib
import * as gtag from "components/GTagManager";
import formatMoney from "lib/formatMoney";
import createLoan from "lib/createLoan";
import updateLoan from "lib/updateLoan";
import updateLoan2 from "lib/updateLoan2";
import PMT from "lib/PMT";
import PV from "lib/PV";
import triggerLoanUpdateEmail from "lib/triggerLoanUpdateEmail";
import newLoanQuoteSlackNotification from "lib/newLoanQuoteSlackNotification";
import excludeAccountQuestionIfLoggedIn from "components/Loans/utils/excludeAccountQuestionIfLoggedIn";
import updateUserProfile from "lib/updateUserProfile";
import getDSCRLoanQuoteData from "components/Loans/utils/getDSCRLoanQuoteData";
import getBridgeLoanQuoteData from "components/Loans/utils/getBridgeLoanQuoteData";
import getGroundUpLoanQuoteData from "components/Loans/utils/getGroundUpLoanQuoteData";

// mui
import Skeleton from "@mui/material/Skeleton";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import RemoveSharpIcon from "@mui/icons-material/RemoveSharp";
import { useTheme } from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import StepButton from "@mui/material/StepButton";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// components
import DSCRCalculatorQuestions from "components/Calculators/DSCRCalculator/components/CalculatorQuestions";

import fixAndFlipInterestRate from "components/Loans/LoanContainer/components/fixAndFlipInterestRate";
import Authenticator from "components/Authenticator";
import questions from "components/Loans/Questions";
import FinalQuoteDisplay from "components/Loans/FinalQuoteDisplay";
import CustomProgressBar from "./CustomProgressBar";
// google maps autocomplete
import dynamic from "next/dynamic";
const AddressAutocomplete = dynamic(() =>
  import("components/AddressAutocomplete")
);

async function sleep(millis) {
  return new Promise((resolve) => setTimeout(resolve, millis));
}
// NOTE
// This is hardcoded here and on the BE
// needs to be changed in both places for now
const slowFlipInterestRate = 15;

function QuoteStepper({ scrollID }) {
  const theme = useTheme();
  const router = useRouter();

  // store
  const {
    gmapsLoaded,
    currentLoan,
    setCurrentLoan,
    user,
    setUser,
    userProfile,
    setUserProfile,
  } = useStore(AppStore);

  const [localQuoterAddress, setLocalQuoterAddress] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [currentValue, setCurrentValue] = useState("");
  const [loanQuoteData, setLoanQuoteData] = useState({});
  const [loanQuoteError, setLoanQuoteError] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState({});
  const [date, setDate] = useState(null);
  const [bridgePurchaseComponent, setBridgePurchaseComponent] = useState(0);
  const [bridgeRehabComponent, setBridgeRehabComponent] = useState(0);
  const [totalLoanLimit, setTotalLoanLimit] = useState(0);
  const [priceLoanLimit, setPriceLoanLimit] = useState(0);
  const [rehabLoanLimit, setRehabLoanLimit] = useState(0);
  const [totalLoanLeft, setTotalLoanLeft] = useState(0);
  const [priceLoanLeft, setPriceLoanLeft] = useState(0);
  const [rehabLoanLeft, setRehabLoanLeft] = useState(0);
  const [rehabLoanLeftDisplay, setRehabLoanLeftDisplay] = useState(0);
  const [answers, setAnswers] = useState("");
  const [suggestionChoice, setSuggestionChoice] = useState();
  const [leadRef, setLeadRef] = useState("");

  useEffect(() => {
    smoothscroll.polyfill();

    let q_id_counter = "";
    let answers = [];
    const questionsSlice = questions.slice(); // make sure to make a copy
    let leftMostPath = questionsSlice.filter((question) => {
      // https://stackoverflow.com/a/21596128/1933331

      return /^0*$/.test(question.q_id);
    });

    // leftMostPath
    // must sort based on q_id length of 0s inside
    // left most paths q_ids
    leftMostPath.sort((a, b) => a.q_id.length - b.q_id.length);

    // leftMostPath for initial state
    // as user selects answers,
    // the path deviates and questions ahead change

    for (let i = 0; i < leftMostPath.length; i++) {
      // TODO DEEEEV
      // for (let i = leftMostPath.length - 10; i < leftMostPath.length; i++) {
      // TODO DEEEEV
      const question = leftMostPath[i];
      q_id_counter = q_id_counter + "0";
      answers.push({
        a_string: "",
        // TODO DEEEV
        q_id: new Array(i + 2).join("0"),
        // q_id: q_id_counter,
        q_description: question.q_description,
        q_title: question.q_title,
        node_type: question.node_type,
        a_type: question.a_type,
        a_input_type: question.a_input_type,
        a_opts: question.a_opts,
        q_next_step_func: question.q_next_step_func,
        q_validation_func: question.q_validation_func,
        q_invalid_answer_help_text: question.q_invalid_answer_help_text,
        a_error: question.a_error,
      });
    }

    // TODO
    // here can pre-populate questions
    // based on users responses so make repeat quotes easier

    const updatedAnswers = excludeAccountQuestionIfLoggedIn(
      user,
      userProfile,
      answers
    );

    setAnswers(updatedAnswers);
  }, []);

  useEffect(() => {
    let updatedAnswers;

    if (user && userProfile && answers && answers.length > 0) {
      // TODO
      // here can pre-populate questions
      // based on users responses so make repeat quotes easier

      updatedAnswers = excludeAccountQuestionIfLoggedIn(
        user,
        userProfile,
        answers
      );

      setAnswers(updatedAnswers);
    }

    if (user && answers && Object.keys(selectedLoan).length > 0) {
      // check what question we are on
      // update loan file
      // redirect to my loans

      // NOTE has to be based on "updatedAnswers"
      // which are based on info thats inside userProfile
      const activeAnswer = updatedAnswers[activeStep];

      if (activeAnswer && activeAnswer.a_type === "my_loan") {
        finalizeSelectedLoanAndRedirect();
      }
    }

    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get("ref");
    if (ref) {
      setLeadRef(ref);
    } else {
      // if lead ref isnt already specified in the url or through other means
      // take the current url as lead ref
      setLeadRef(router?.asPath);
    }
  }, [user, userProfile]);

  // Fix and flip loan amount question calculations
  // based on what user input
  useEffect(() => {
    const totalLoanLeft =
      parseInt(totalLoanLimit) -
      parseInt(bridgePurchaseComponent) -
      parseInt(bridgeRehabComponent);

    let priceLoanLeft =
      parseInt(priceLoanLimit) - parseInt(bridgePurchaseComponent);

    const rehabLoanLeft =
      parseInt(totalLoanLimit) - parseInt(bridgePurchaseComponent);

    setTotalLoanLeft(parseInt(totalLoanLeft));
    setPriceLoanLeft(parseInt(priceLoanLeft));
    setRehabLoanLeft(parseInt(rehabLoanLeft));
  }, [bridgePurchaseComponent, bridgeRehabComponent]);

  useEffect(() => {
    const activeAnswer = answers[activeStep];

    // if BRIDGE LOAN amount is being asked
    // this will calculate initial amounts
    // and another useEffect will respond to user's inputs
    let currenLoanQuoteData;
    if (activeAnswer?.q_title === "Fix and flip loan amount") {
      (async () => {
        await getBridgeLoanQuoteData(
          answers,
          setTotalLoanLimit,
          setPriceLoanLimit,
          setRehabLoanLimit,
          setTotalLoanLeft,
          setPriceLoanLeft,
          setRehabLoanLeft,
          setRehabLoanLeftDisplay,
          false,
          setBridgePurchaseComponent,
          setBridgeRehabComponent
        );
      })();
    }

    if (activeAnswer?.q_title === "Ground up construction loan amount") {
      (async () => {
        await getGroundUpLoanQuoteData(
          answers,
          setTotalLoanLimit,
          setPriceLoanLimit,
          setRehabLoanLimit,
          setTotalLoanLeft,
          setPriceLoanLeft,
          setRehabLoanLeft,
          setRehabLoanLeftDisplay,
          setBridgePurchaseComponent,
          setBridgeRehabComponent
        );
      })();
    }

    // QUOTE API CALL
    // This is atypical step, where questions own function
    // isnt enough. We pass on all the info we gathered
    // so far to conduct an api call to get final quote
    if (activeAnswer && activeAnswer.a_type === "final_quote") {
      const loanType = answers?.filter((answer) => {
        return answer.q_title === "Loan type";
      })[0]?.a_string;
      const loanPurpose = answers?.filter((answer) => {
        return answer?.q_title === "Loan purpose";
      })?.[0]?.a_string;

      const portfolioLoan = answers?.filter((answer) => {
        return answer.q_title === "Portfolio loan";
      })[0]?.a_string;

      if (loanType === "Fix and flip") {
        const bridgeLoanAmounts = answers?.filter((answer) => {
          return answer.q_title === "Fix and flip loan amount";
        })[0]?.a_string;

        const loanAmount =
          (bridgeLoanAmounts[0] && parseInt(bridgeLoanAmounts[0])) +
          (bridgeLoanAmounts[1] && parseInt(bridgeLoanAmounts[1]));

        // const originationFee =
        //   parseInt(loanAmount) < 100000 ? 2000 : loanAmount * 0.02;
        const mortgagePmt = (loanAmount * (fixAndFlipInterestRate / 100)) / 12;
        const partialMortgagePmt =
          ((bridgeLoanAmounts[0] && parseInt(bridgeLoanAmounts[0])) *
            (fixAndFlipInterestRate / 100)) /
          12;

        if (portfolioLoan > 1) {
          // PORTFOLIO BRIDGE LOAN
          setLoanQuoteData({
            loanType: "Fix and flip",
            portfolio: true,
            loanAmount: loanAmount,
            // originationFee: originationFee,
            mortgagePmt: mortgagePmt,
            partialMortgagePmt: partialMortgagePmt,
          });
        } else {
          // SINGLE PROPERTY BRIGE LOAN, NOT PORTOLIO
          setLoanQuoteData({
            loanType: "Fix and flip",
            portfolio: false,
            loanAmount: loanAmount,
            // originationFee: originationFee,
            mortgagePmt: mortgagePmt,
          });
        }
      } else if (loanType === "Ground up construction") {
        const groundUpLoanAmounts = answers?.filter((answer) => {
          return answer.q_title === "Ground up construction loan amount";
        })[0]?.a_string;

        const loanAmount =
          (groundUpLoanAmounts[0] && parseInt(groundUpLoanAmounts[0])) +
          (groundUpLoanAmounts[1] && parseInt(groundUpLoanAmounts[1]));

        // const originationFee =
        //   parseInt(loanAmount) < 200000 ? 2000 : loanAmount * 0.01;
        const mortgagePmt = Math.round(
          (loanAmount * (fixAndFlipInterestRate / 100)) / 12
        );

        // SINGLE PROPERTY BRIGE LOAN, NOT PORTOLIO
        setLoanQuoteData({
          loanType: "Ground up construction",
          portfolio: false,
          loanAmount: loanAmount,
          // originationFee: originationFee,
          mortgagePmt: mortgagePmt,
        });
      } else if (loanType === "Slow flip") {
        const asIsValue = answers?.filter((answer) => {
          return answer.q_title === "Estimated AS-IS value";
        })[0]?.a_string;

        const purchasePrice = answers?.filter((answer) => {
          return answer.q_title === "Purchase price";
        })[0]?.a_string;

        const monthlyRent = answers?.filter((answer) => {
          return answer.q_title === "Monthly rent";
        })[0]?.a_string;

        // asIsValue
        const maxValue = 50000;
        let loanAmount = 0;
        if (parseInt(purchasePrice) > maxValue) {
          loanAmount = maxValue;
        } else {
          loanAmount = parseInt(purchasePrice);
        }

        // min value check
        const slowFlipMin = 10000;
        if (loanAmount < slowFlipMin) {
          loanAmount = "Loan amount too low";
        }

        let monthlyPMT = 0;
        const ir = slowFlipInterestRate / 100 / 12;
        const np = 5 * 12;
        const pv = loanAmount;
        if (loanAmount !== "Loan amount too low") {
          monthlyPMT = PMT(ir, np, pv).toFixed(2) * -1;
        } else {
          monthlyPMT = 0;
        }

        if (parseInt(monthlyRent) < monthlyPMT) {
          loanAmount = -1 * PV(ir, np, parseInt(monthlyRent), 0);
          monthlyPMT = parseInt(monthlyRent);
        }

        let propertyValue;
        if (loanPurpose === "Purchase") {
          const purchasePrice = answers.filter((answer) => {
            return answer.q_title === "Purchase price";
          })[0]?.a_string;
          propertyValue = purchasePrice;
        }

        if (loanPurpose === "Refinance") {
          const estimatedAsIsValue = answers.filter((answer) => {
            return answer.q_title === "Estimated AS-IS value";
          })[0]?.a_string;
          propertyValue = estimatedAsIsValue;
        }

        const LTV = ((loanAmount / propertyValue) * 100).toFixed(2);

        setLoanQuoteData({
          loanType: "Slow flip",
          portfolio: false,
          loanAmount: loanAmount,
          // originationFee: 2000,
          mortgagePmt: monthlyPMT,
          loanInterestRate: 0.12,
          loanInterestRate: slowFlipInterestRate,
          ltv: LTV,
        });
      } else {
        // NOT A BRIDGE LOAN OR A GROUND UP
        // then just show our flat rate quote
        // if this is not, then get quote
        (async () => {
          await getDSCRLoanQuoteData(answers, setLoanQuoteData);
        })();
      }
    }

    // if normal submission at the end
    // with user logged in

    if (activeAnswer && activeAnswer.a_type === "my_loan") {
      finalizeSelectedLoanAndRedirect();
    }
  }, [activeStep]);

  useEffect(() => {
    if (loanQuoteData.errors) {
      setLoanQuoteError(true);
    }
  }, [loanQuoteData]);

  const handleNext = () => {
    const activeAnswer = answers[activeStep];

    if (activeStep === 0) {
      if (!currentLoan.id) {
        (async () => {
          // New Loan (aka, quote started, becomes full fledged loan, when user submist and UID from user is assigned to a loans record)
          const newLoan = await createLoan(answers, setCurrentLoan);
          gtag.event({ action: "start_quote" });
        })();
      } else {
        (async () => {
          await updateLoan(
            user,
            answers,
            setCurrentLoan,
            currentLoan,
            loanQuoteData,
            selectedLoan,
            {
              FirstName: userProfile?.FirstName,
              LastName: userProfile?.LastName,
              PhoneNumber: userProfile?.phoneNumber, // user profile phone num already has a leading 1
              Email: user?.email,
              UID: user?.uid,
              Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
                ? Intl.DateTimeFormat().resolvedOptions().timeZone
                : "UTC",
            }
          );
        })();
      }
    } else {
      // do this on each step except final_quote
      // because selectedLoan is set in the update in that step
      // but if it gets here, its overwritten with nothing

      if (!["final_quote", "my_loan"].includes(activeAnswer.a_type)) {
        // make sure we capture leadRef on first click of the quote

        let updatedSelectedLoan;
        if (leadRef && !selectedLoan.leadRef) {
          updatedSelectedLoan = Object.assign({}, selectedLoan);
          updatedSelectedLoan.leadRef = leadRef;
        } else {
          updatedSelectedLoan = Object.assign({}, selectedLoan);
        }

        (async () => {
          await updateLoan(
            user,
            answers,
            setCurrentLoan,
            currentLoan,
            loanQuoteData,
            updatedSelectedLoan,
            {
              FirstName: userProfile?.FirstName,
              LastName: userProfile?.LastName,
              PhoneNumber: userProfile?.phoneNumber, // user profile phone num already has a leading 1
              Email: user?.email,
              UID: user?.uid,
              Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
                ? Intl.DateTimeFormat().resolvedOptions().timeZone
                : "UTC",
            }
          );
        })();
      }
    }

    // set step
    setActiveStep((prevActiveStep) => {
      return prevActiveStep + 1;
    });
    // bring into view

    setTimeout(() => {
      document
        .getElementById(
          scrollID
            ? `${scrollID}_question_${activeStep}`
            : `question_${activeStep}`
        )
        .scrollIntoView({
          behavior: "smooth",
        });
    }, 100);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    setTimeout(() => {
      document
        .getElementById(
          scrollID ? `${scrollID}_question_${0}` : `question_${0}`
        )
        .scrollIntoView({
          behavior: "smooth",
        });
    }, 100);
  };

  const shouldSaveToUserProfile = (answer, val) => {
    // phone, email, first, last are special
    // and need to be updated in user profile
    if (["Email", "First name", "Last name"].includes(answer.q_title)) {
      let keyName;
      switch (answer.q_title) {
        case "Email":
          keyName = "Email";
          break;
        case "First name":
          keyName = "FirstName";
          break;
        case "Last name":
          keyName = "LastName";
          break;
      }
      updateUserProfile(userProfile, user, {
        [keyName]: val,
      });
    }
  };

  const handleStep = (step) => {
    if (step < activeStep) {
      setActiveStep(step);
    }
  };

  const generateAnswerOptions = (answer, index, answers, activeStep) => {
    const questionsSlice = questions.slice();

    // PROCESS SUBMISSIONS
    const processSubmission = (
      value,
      saveToAnswers = true // we dont want to save passwords or anything else sensitive,
    ) => {
      let updatedAnswers = answers.slice();

      // validate the answer
      const isValidAnswer = answer.q_validation_func(value, answers);

      if (isValidAnswer) {
        // update answers
        // with value of the answer
        const targetAnswer = updatedAnswers.filter((updatedAnswer) => {
          return updatedAnswer.q_id === answer.q_id;
        })[0];
        // set answer

        // save to answers is primarily meant for password
        // field not to be populated and saved into the loan file
        // while taking all other advantages of this processSubmission functionality
        if (saveToAnswers) {
          // only exception is Q-id 0..
          // need to overwrite types
          if (answer.q_id === "0") {
            let overwrittenValue;
            switch (value) {
              case "Bridge":
              case "Hard money":
                overwrittenValue = "Fix and flip";
                break;
              case "Low balance":
                overwrittenValue = "Slow flip";
                break;
              default:
                overwrittenValue = value;
            }

            targetAnswer.a_string = overwrittenValue;
            targetAnswer.a_overwritten_value = value; // this is a way to retain what was the actual
          } else {
            targetAnswer.a_string = value;
          }
        }
        // reset error just in case
        targetAnswer.a_error = false;

        // determine next question
        const next_q_id = answer.q_next_step_func(answer, answers, questions);

        // NEXT QUESTION is always next in position
        // NOT like before when it was based on length of q_id
        // this was limiting in terms of folding questions of the tree back
        // and allowing the tree to merge back to left most path
        const posOfNextQuestion =
          updatedAnswers
            .map((updatedAnswer) => {
              return updatedAnswer.q_id;
            })
            .indexOf(answer.q_id) + 1;

        const nextPotentialQuestion = updatedAnswers[posOfNextQuestion];

        if (nextPotentialQuestion.q_id !== next_q_id) {
          // OFF LEFT MOST PATH
          const newNextQuestion = questionsSlice.filter((question) => {
            return question.q_id === next_q_id;
          })[0];

          // LEAF, remove all subsequent questions from answers
          if (newNextQuestion.node_type === "leaf") {
            // if a LEAF never delete anything (like using slice)
            // instead add hidden property
            for (let i = posOfNextQuestion; i < updatedAnswers.length; i++) {
              updatedAnswers[i].node_visibility = "hidden";
            }
          } else {
            // NODE, make sure subsequent questions are prents
            // need to make left most path starting from next questions's id.

            let leftMostPathFromCurrentNode = [];
            let deeperNextQuestion = newNextQuestion;
            let deeperNextQuestionChildrenLength =
              deeperNextQuestion.q_child_nodes.length;
            const map_q_id = questionsSlice.map((question) => {
              return question.q_id;
            });

            while (deeperNextQuestionChildrenLength !== 0) {
              // WRONG ASSUMPTION HERE...
              // OLD
              // deeperNextQuestion =
              //   questions[
              //     map_q_id.indexOf(deeperNextQuestion.q_child_nodes[0])
              //   ];
              // q_next_step_func determins next question
              // not q_child_nodes...

              // SOLUTION
              // will rewrite, q_child_nodes to include possible end scenarios
              // q_ids while q_next_step_func actually determines the path, between the options that are available at the end
              // this way can prebuild paths before actual answers are know and its not barried inside deciding function (so its easier to access)
              // NEW
              // NEW take 2
              // expecting q_next_step_func, on null case to return left most path
              deeperNextQuestion =
                questions[
                  map_q_id.indexOf(
                    deeperNextQuestion.q_next_step_func(
                      deeperNextQuestion,
                      [],
                      []
                    )
                  )
                ];

              if (deeperNextQuestion) {
                deeperNextQuestionChildrenLength =
                  deeperNextQuestion.q_child_nodes.length;

                leftMostPathFromCurrentNode.push(deeperNextQuestion);
              } else {
                deeperNextQuestionChildrenLength = 0;
              }
            }

            // then just slice it in...
            // instead of looping
            // and handleNext shouldnt need to be changed

            const earlierQuestions = updatedAnswers.slice(
              0,
              posOfNextQuestion + 2
            );

            let counter = 0;
            for (
              let i = posOfNextQuestion + 1;
              i < leftMostPathFromCurrentNode.length + posOfNextQuestion + 1;
              i++
            ) {
              if (
                updatedAnswers[i]?.q_id === leftMostPathFromCurrentNode[counter]
              ) {
                //show the node
                // updatedAnswers[i].node_type = "node";
              } else {
                //or overwrite if different
                updatedAnswers[i] = leftMostPathFromCurrentNode[counter];
                // updatedAnswers[i].node_type = "node";
              }
              counter = counter + 1;
            }

            // make sure all nodes are re-updated
            // to have node_type be node so nothing is hidden
            // if people jump around

            for (let i = 0; i < updatedAnswers.length; i++) {
              if (updatedAnswers[i].node_type === "node") {
                updatedAnswers[i].node_visibility = "visible";
              }
            }
          }

          updatedAnswers[posOfNextQuestion] = questionsSlice.filter(
            (question) => {
              return question.q_id === next_q_id;
            }
          )[0];
          updatedAnswers[posOfNextQuestion].node_visibility = "visible";
        }

        updatedAnswers = excludeAccountQuestionIfLoggedIn(
          user,
          userProfile,
          updatedAnswers
        );

        setAnswers(updatedAnswers);
      } else {
        updatedAnswers.filter((updatedAnswer) => {
          return updatedAnswer.q_id === answer.q_id;
        })[0].a_error = true;

        updatedAnswers = excludeAccountQuestionIfLoggedIn(
          user,
          userProfile,
          updatedAnswers
        );

        setAnswers(updatedAnswers);
      }
    };

    let answerOptionsUI;

    switch (answer.a_type) {
      case "leaf":
        answerOptionsUI = (
          <>
            <Box sx={{ mb: 2 }}>
              <div>
                {answer.node_type !== "leaf" && answer.a_type !== "mc" && (
                  <Button
                    key={`${answer.q_id}_button_next`}
                    variant="contained"
                    onClick={() => {
                      if (!answer.a_error) {
                        handleNext();
                      }
                    }}
                    sx={{
                      mt: 1,
                      mr: 1,
                      color: "white !important",
                      "&:hover, :focus": {
                        color: `${theme.palette.primary.contrastColor} !important`,
                        backgroundColor: `${theme.palette.success.dark} !important`,
                      },
                    }}
                  >
                    {index === answers.length - 1 ? "Finish" : "Continue"}
                  </Button>
                )}
                <Button
                  key={`${answer.q_id}_button_back`}
                  variant={
                    answer.node_type !== "leaf" && answer.a_type !== "mc"
                      ? "text"
                      : "contained"
                  }
                  disabled={index === 0}
                  onClick={handleBack}
                  sx={{ mt: 1, mr: 1 }}
                >
                  Back
                </Button>
              </div>
            </Box>
          </>
        );
        break;
      case "number":
        answerOptionsUI = (
          <>
            <Box>
              <TextField
                autoFocus={true}
                // autoFocus={answer.q_id !== "0"}
                sx={
                  answer.q_id == "0"
                    ? {
                        margin: theme.spacing(5, 0),
                        "& label.Mui-focused": {
                          color: theme.palette.success.dark,
                        },
                        "& .MuiInput-underline:after": {
                          borderBottomColor: "green",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: theme.palette.success.dark,
                          },
                          "&:hover fieldset": {
                            borderColor: theme.palette.success.dark,
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: theme.palette.success.dark,
                          },
                        },
                      }
                    : { margin: theme.spacing(5, 0) }
                }
                error={answer.a_error}
                label={answer.a_error ? "Error" : answer.q_title}
                type={answer.a_input_type}
                value={
                  answer.a_input_type === "currency"
                    ? currentValue !== ""
                      ? currentValue === false
                        ? answer.a_string
                          ? `$${formatMoney(answer.a_string, 0)}`
                          : `$`
                        : `$${formatMoney(currentValue, 0)}`
                      : `$`
                    : currentValue !== ""
                    ? currentValue === false
                      ? answer.a_string
                      : currentValue
                    : currentValue
                }
                onChange={(e) => {
                  const num = e.target.value.replace(/\D/g, "");
                  setCurrentValue(num);
                }}
                InputProps={{
                  min: answer.a_opts(answers)[0] && answer.a_opts(answers)[0],
                  max: answer.a_opts(answers)[1] && answer.a_opts(answers)[1],
                }}
                inputProps={{
                  inputMode: "numeric", // this makes mobile to pull up numbers only keyboard
                }}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    const num = e.target.value.replace(/\D/g, "");
                    processSubmission(num);
                    if (!answer.a_error) {
                      handleNext();
                      setCurrentValue(false);
                    }
                  }
                }}
                onBlur={(e) => {
                  const num = e.target.value.replace(/\D/g, "");
                  processSubmission(num);
                }}
                helperText={
                  answer.a_error ? answer.q_invalid_answer_help_text : ""
                }
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <div>
                {answer.node_type !== "leaf" && answer.a_type !== "mc" && (
                  <Button
                    variant="contained"
                    onClick={() => {
                      // current value might be blank if user
                      // is traversing back and value is actually stored
                      // in answer instead of current value
                      if (currentValue === false) {
                        processSubmission(answer.a_string);
                      } else {
                        processSubmission(currentValue);
                      }
                      if (!answer.a_error) {
                        handleNext();
                        setCurrentValue(false);
                      }
                    }}
                    sx={{
                      mt: 1,
                      mr: 1,
                      color: "white !important",
                      "&:hover, :focus": {
                        color: `${theme.palette.primary.contrastColor} !important`,
                        backgroundColor: `${theme.palette.success.dark} !important`,
                      },
                    }}
                  >
                    {index === answers.length - 1 ? "Quote" : "Continue"}
                  </Button>
                )}
                {index !== 0 && (
                  <Button
                    variant={
                      answer.node_type !== "leaf" && answer.a_type !== "mc"
                        ? "text"
                        : "contained"
                    }
                    disabled={index === 0}
                    onClick={handleBack}
                    sx={{ mt: 1, mr: 1 }}
                  >
                    Back
                  </Button>
                )}
              </div>
            </Box>
          </>
        );
        break;
      case "date":
        answerOptionsUI = (
          <>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={answer.q_title}
                  value={dayjs(date)}
                  onChange={(newDate) => {
                    setDate(newDate);
                  }}
                  onBlur={(newDate) => {
                    processSubmission(newDate);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Box>
            <Box sx={{ mb: 2 }}>
              <div>
                <Button
                  variant="contained"
                  onClick={() => {
                    // current value might be blank if user
                    // is traversing back and value is actually stored
                    // in answer instead of current value
                    if (date === false) {
                      processSubmission(answer.a_string);
                    } else {
                      processSubmission(date);
                    }
                    if (!answer.a_error) {
                      handleNext();
                      setCurrentValue(false);
                    }
                  }}
                  sx={{
                    mt: 1,
                    mr: 1,
                    color: "white !important",
                    "&:hover, :focus": {
                      color: `${theme.palette.primary.contrastColor} !important`,
                      backgroundColor: `${theme.palette.success.dark} !important`,
                    },
                  }}
                >
                  Continue
                </Button>

                <Button
                  variant={
                    answer.node_type !== "leaf" && answer.a_type !== "mc"
                      ? "text"
                      : "contained"
                  }
                  disabled={index === 0}
                  onClick={handleBack}
                  sx={{ mt: 1, mr: 1 }}
                >
                  Back
                </Button>
              </div>
            </Box>
          </>
        );
        break;
      case "mc":
        answerOptionsUI = (
          <>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              {answer.a_opts(answers).map((a_opt, index) => {
                {
                  return (
                    <Button
                      sx={{
                        margin: theme.spacing(1),
                        color: "white !important",
                        "&:hover, :focus": {
                          color: `${theme.palette.primary.contrastColor} !important`,
                          backgroundColor: `${theme.palette.success.dark} !important`,
                        },
                      }}
                      variant="contained"
                      onClick={(e) => {
                        processSubmission(a_opt);
                        handleNext();
                      }}
                    >
                      {a_opt}
                    </Button>
                  );
                }
              })}
            </Box>
            <Box sx={{ mb: 2 }}>
              <div>
                {answer.node_type !== "leaf" && answer.a_type !== "mc" && (
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (!answer.a_error) {
                        handleNext();
                      }
                    }}
                    sx={{
                      mt: 1,
                      mr: 1,
                      color: "white !important",
                      "&:hover, :focus": {
                        color: `${theme.palette.primary.contrastColor} !important`,
                        backgroundColor: `${theme.palette.success.dark} !important`,
                      },
                    }}
                  >
                    {index === answers.length - 1 ? "Finish" : "Continue"}
                  </Button>
                )}
                {index !== 0 && (
                  <Button
                    variant={
                      answer.node_type !== "leaf" && answer.a_type !== "mc"
                        ? "text"
                        : "contained"
                    }
                    disabled={index === 0}
                    onClick={handleBack}
                    sx={{ mt: 1, mr: 1 }}
                  >
                    Back
                  </Button>
                )}
              </div>
            </Box>
          </>
        );
        break;
      case "address":
        const portfolioLoan = answers.filter((answer) => {
          return answer.q_title === "Portfolio loan";
        })?.[0]?.a_string;

        const address = answers.filter((answer) => {
          return answer.q_title === "Address";
        })?.[0]?.a_string;

        answerOptionsUI = (
          <>
            <Box sx={{ margin: theme.spacing(3, 3, 3, 0) }}>
              <AddressAutocomplete
                onInputChange={(value) => {
                  // Track what user types for fallback
                  setLocalQuoterAddress(value);
                }}
                onAddressSelect={({ place, inputValue, source }) => {
                  // Use place address if available, otherwise use raw input
                  const selectedAddress =
                    place?.formatted_address || inputValue;

                  setSuggestionChoice(selectedAddress);
                  processSubmission(selectedAddress);

                  if (!answer.a_error) {
                    handleNext(); // Auto-advance in QuoteStepper
                  }
                }}
                initialAddress={address !== "" ? address : ""}
                label={
                  answer.a_error
                    ? answer.q_invalid_answer_help_text
                    : answer.q_title
                }
                ariaLabel="Enter address of the property for this loan"
                searchOptionsTypes={[]}
                error={answer.a_error}
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <div>
                {answer.node_type !== "leaf" && answer.a_type !== "mc" && (
                  <Button
                    variant="contained"
                    onClick={() => {
                      // Use saved answer or fall back to what user typed
                      const addressToSubmit =
                        answer.a_string || localQuoterAddress;

                      if (addressToSubmit) {
                        processSubmission(addressToSubmit);
                      }

                      if (!answer.a_error) {
                        handleNext();
                      }
                    }}
                    sx={{
                      mt: 1,
                      mr: 1,
                      color: "white !important",
                      "&:hover, :focus": {
                        color: `${theme.palette.primary.contrastColor} !important`,
                        backgroundColor: `${theme.palette.success.dark} !important`,
                      },
                    }}
                  >
                    {index === answers.length - 1 ? "Finish" : "Continue"}
                  </Button>
                )}
                <Button
                  variant={
                    answer.node_type !== "leaf" && answer.a_type !== "mc"
                      ? "text"
                      : "contained"
                  }
                  disabled={index === 0}
                  onClick={handleBack}
                  sx={{ mt: 1, mr: 1 }}
                >
                  Back
                </Button>
              </div>
            </Box>
          </>
        );
        break;
      case "final_quote":
        const processQuote = (answerVal) => {
          const oldSelectedLoan = Object.assign({}, selectedLoan);

          const updatedSelectedLoan = Object.assign(oldSelectedLoan, answerVal);

          setSelectedLoan(updatedSelectedLoan);

          const uid = user?.uid;

          (async () => {
            handleNext();
          })();
        };

        answerOptionsUI = (
          <>
            <Box>
              {Object.keys(loanQuoteData).length === 0 ? (
                "Calculating Quote...."
              ) : (
                <Box>
                  <Box>
                    {!loanQuoteError ? (
                      <FinalQuoteDisplay
                        loanQuoteData={loanQuoteData}
                        answers={answers}
                        processQuote={processQuote}
                      />
                    ) : (
                      <Box>
                        Something went wrong. Please press button below to get
                        live help:
                      </Box>
                    )}
                  </Box>
                </Box>
              )}
            </Box>

            <Box sx={{ margin: theme.spacing(4, "auto") }}>
              <ul>
                <li>
                  This instant quote is subject to review and is not a guarantee
                  of available interest rate or loan amount
                </li>
                <li>
                  Click 'SELECT' and submit your quote request so a member of
                  our team can confirm the best available offer
                </li>
              </ul>
            </Box>
            <Box sx={{ mb: 2 }}>
              <div>
                <Button
                  disabled={index === 0}
                  onClick={handleBack}
                  sx={{ mt: 1, mr: 1 }}
                >
                  Back
                </Button>
              </div>
            </Box>
          </>
        );
        break;
      case "text":
        answerOptionsUI = (
          <>
            <Box>
              <Box>
                <Box>
                  <TextField
                    autoFocus
                    sx={{ margin: theme.spacing(5, 0) }}
                    error={answer.a_error}
                    label={answer.a_error ? "Error" : answer.q_title}
                    type={answer.a_input_type}
                    value={
                      currentValue !== ""
                        ? currentValue === false
                          ? answer.a_string
                          : currentValue
                        : currentValue
                    }
                    onChange={(e) => {
                      const val = e.target.value;
                      setCurrentValue(val);
                    }}
                    InputProps={{
                      min:
                        answer.a_opts(answers)[0] && answer.a_opts(answers)[0],
                      max:
                        answer.a_opts(answers)[1] && answer.a_opts(answers)[1],
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        const val = e.target.value;
                        processSubmission(val);
                        shouldSaveToUserProfile(answer, val);
                        if (!answer.a_error) {
                          handleNext();
                          setCurrentValue(false);
                        }
                      }
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      processSubmission(val);
                      shouldSaveToUserProfile(answer, val);
                    }}
                    helperText={
                      answer.a_error ? answer.q_invalid_answer_help_text : ""
                    }
                  />
                </Box>
              </Box>
            </Box>

            <Box sx={{ mb: 2 }}>
              <div>
                <Button
                  variant="contained"
                  onClick={() => {
                    // current value might be blank if user
                    // is traversing back and value is actually stored
                    // in answer instead of current value
                    if (currentValue === false) {
                      processSubmission(answer.a_string);
                      shouldSaveToUserProfile(answer, answer.a_string);
                    } else {
                      processSubmission(currentValue);
                      shouldSaveToUserProfile(answer, currentValue);
                    }
                    if (!answer.a_error) {
                      handleNext();
                      setCurrentValue(false);
                    }
                  }}
                  sx={{
                    mt: 1,
                    mr: 1,
                    color: "white !important",
                    "&:hover, :focus": {
                      color: `${theme.palette.primary.contrastColor} !important`,
                      backgroundColor: `${theme.palette.success.dark} !important`,
                    },
                  }}
                >
                  Continue
                </Button>
                <Button
                  disabled={index === 0}
                  onClick={handleBack}
                  sx={{ mt: 1, mr: 1 }}
                >
                  Back
                </Button>
              </div>
            </Box>
          </>
        );
        break;
      case "phone_number":
        answerOptionsUI = (
          <>
            <Box>
              <TextField
                id="outlined-start-adornment"
                autoFocus
                sx={{ margin: theme.spacing(5, 0) }}
                error={answer.a_error}
                label={answer.a_error ? "Error" : answer.q_title}
                type={answer.a_input_type}
                value={
                  currentValue !== ""
                    ? currentValue === false
                      ? answer.a_string
                      : currentValue
                    : currentValue
                }
                onChange={(e) => {
                  const val = e.target.value;
                  setCurrentValue(val);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">+1</InputAdornment>
                  ),
                }}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    const val = e.target.value;
                    processSubmission(val);
                    // phone, email, first, last also need to be update in userprofile
                    updateUserProfile(userProfile, user, {
                      PhoneNumber: val,
                    });
                    if (!answer.a_error) {
                      handleNext();
                      setCurrentValue(false);
                    }
                  }
                }}
                onBlur={(e) => {
                  const val = e.target.value;
                  processSubmission(val);
                  // phone, email, first, last also need to be update in userprofile
                  updateUserProfile(userProfile, user, {
                    PhoneNumber: val,
                  });
                }}
                helperText={
                  answer.a_error ? answer.q_invalid_answer_help_text : ""
                }
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <div>
                <Button
                  variant="contained"
                  onClick={() => {
                    // current value might be blank if user
                    // is traversing back and value is actually stored
                    // in answer instead of current value
                    if (currentValue === false) {
                      processSubmission(answer.a_string);
                      // phone, email, first, last also need to be update in userprofile
                      updateUserProfile(userProfile, user, {
                        PhoneNumber: answer.a_string,
                      });
                    } else {
                      processSubmission(currentValue);
                      // phone, email, first, last also need to be update in userprofile
                      updateUserProfile(userProfile, user, {
                        PhoneNumber: currentValue,
                      });
                    }
                    if (!answer.a_error) {
                      handleNext();
                      setCurrentValue(false);
                    }
                  }}
                  sx={{
                    mt: 1,
                    mr: 1,
                    color: "white !important",
                    "&:hover, :focus": {
                      color: `${theme.palette.primary.contrastColor} !important`,
                      backgroundColor: `${theme.palette.success.dark} !important`,
                    },
                  }}
                >
                  Continue
                </Button>
                <Button
                  disabled={index === 0}
                  onClick={handleBack}
                  sx={{ mt: 1, mr: 1 }}
                >
                  Back
                </Button>
              </div>
            </Box>
          </>
        );
        break;
      case "my_loan":
        // when this question becomes visible
        // has to do it this way because useEffect on activeStep
        // doens't pick up changes when setting active step to the same
        // number after login in useEffect[user] (since we filter out account and few other)
        // questions based on what user already has filled out in their profile

        answerOptionsUI = (
          <>
            <Box sx={{ margin: theme.spacing(5) }}>
              <CustomProgressBar />
            </Box>
          </>
        );
        break;
      case "bridge_loan":
        const loanPurpose = answers.filter((answer) => {
          return answer.q_title === "Loan purpose";
        })[0].a_string;
        const loanPurposeString = loanPurpose && loanPurpose.toLowerCase();

        answerOptionsUI = (
          <>
            {answer.a_error && (
              <Box sx={{ color: "red" }}>
                {answer.q_invalid_answer_help_text}
              </Box>
            )}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box
                sx={{
                  margin: theme.spacing(2, 0, 0, 0),
                }}
              >
                <Typography>
                  {[
                    <span>We can lend up to</span>,
                    <b> ${formatMoney(totalLoanLimit, 0)}</b>,
                    <span> for the </span>,
                    <b>total</b>,
                    <span> loan. </span>,
                  ]}
                </Typography>
                <br />
                <Typography>
                  {[
                    <span> Maximum we can lend for the </span>,
                    <b>{loanPurposeString}</b>,
                    <span> is </span>,
                    <b>${formatMoney(priceLoanLimit, 0)}</b>,
                    <br />,
                  ]}
                  {priceLoanLeft < 0 && [
                    <span style={{ color: "red" }}>
                      You've entered more than maximum
                    </span>,

                    <span style={{ color: "red" }}> for the </span>,
                    <b style={{ color: "red" }}>{loanPurposeString}</b>,
                  ]}
                </Typography>
              </Box>

              <TextField
                sx={{ margin: theme.spacing(2, 0) }}
                error={priceLoanLeft < 0}
                label={
                  answer.a_error ? "Error" : `For the ${loanPurposeString}?`
                }
                type={answer.a_input_type}
                value={
                  bridgePurchaseComponent === 0
                    ? ""
                    : `$${formatMoney(bridgePurchaseComponent, 0)}`
                }
                onChange={(e) => {
                  const num = e.target.value.replace(/\D/g, "");
                  setBridgePurchaseComponent(num);
                }}
              />
              <Box
                sx={{
                  margin: theme.spacing(2, 0, 0, 0),
                }}
              >
                <Typography>
                  {}
                  {totalLoanLeft < 0
                    ? [
                        <span style={{ color: "red" }}>
                          This is more than we can lend by{" "}
                        </span>,
                        <b style={{ color: "red" }}>
                          ${formatMoney(-1 * totalLoanLeft, 0)}
                        </b>,
                        <span style={{ color: "red" }}> for the </span>,
                        <b style={{ color: "red" }}> rehab </b>,
                        <span style={{ color: "red" }}>
                          {" "}
                          component of the bridge loan.
                        </span>,
                      ]
                    : [
                        <span>Out of the total loan you have </span>,
                        <b>${formatMoney(rehabLoanLeft, 0)}</b>,
                        <span> left for the </span>,
                        <b>rehab</b>,
                        <br />,
                      ]}
                </Typography>
              </Box>

              <TextField
                variant="outlined"
                sx={{ margin: theme.spacing(2, 0) }}
                error={totalLoanLeft < 0}
                disabled={bridgePurchaseComponent === ""}
                label={answer.a_error ? "Error" : "For the rehab?"}
                type={answer.a_input_type}
                value={
                  bridgeRehabComponent === 0
                    ? ""
                    : `$${formatMoney(bridgeRehabComponent, 0)}`
                }
                onChange={(e) => {
                  const num = e.target.value.replace(/\D/g, "");

                  setBridgeRehabComponent(num);
                }}
              />

              <Box
                sx={{
                  margin: theme.spacing(2, 0, 0, 0),
                }}
              ></Box>
              <Typography>
                {totalLoanLeft < 0
                  ? [
                      <span style={{ color: "red" }}>
                        This is more than we can lend by{" "}
                      </span>,
                      <b style={{ color: "red" }}>
                        ${formatMoney(-1 * totalLoanLeft, 0)}
                      </b>,
                    ]
                  : [
                      <span>You can borrow up to </span>,
                      <b style={{ color: "green" }}>
                        ${formatMoney(totalLoanLeft, 0)}
                      </b>,
                      <span> more </span>,
                    ]}
              </Typography>
              <TextField
                disabled={true}
                sx={{
                  margin: theme.spacing(2, 0),
                  "& .MuiOutlinedInput-input": {
                    color:
                      totalLoanLeft < 0
                        ? theme.palette.error.main
                        : theme.palette.success.main,
                    "-webkit-text-fill-color":
                      totalLoanLeft < 0
                        ? theme.palette.error.main
                        : theme.palette.success.main,
                  },
                }}
                error={totalLoanLeft < 0}
                label={answer.a_error ? "Error" : "Total Loan Amount"}
                type={answer.a_input_type}
                value={
                  totalLoanLeft < 0
                    ? "Error"
                    : bridgePurchaseComponent !== 0 ||
                      bridgeRehabComponent !== 0
                    ? `$${formatMoney(
                        (bridgePurchaseComponent !== ""
                          ? parseInt(bridgePurchaseComponent)
                          : 0) +
                          (bridgeRehabComponent !== ""
                            ? parseInt(bridgeRehabComponent)
                            : 0),
                        0
                      )}`
                    : answer.a_string && answer.a_string.length > 1
                    ? `$${formatMoney(
                        answer.a_string[0] + answer.a_string[1],
                        0
                      )}`
                    : `$`
                }
                InputProps={{
                  min: answer.a_opts(answers)[0] && answer.a_opts(answers)[0],
                  max: answer.a_opts(answers)[1] && answer.a_opts(answers)[1],
                }}
              />
            </Box>

            <Box sx={{ mb: 2 }}>
              <div>
                {totalLoanLimit > -1 && (
                  <Button
                    variant="contained"
                    onClick={() => {
                      processSubmission([
                        bridgePurchaseComponent,
                        bridgeRehabComponent,
                      ]);
                      if (!answer.a_error) {
                        handleNext();
                      }
                    }}
                    sx={{
                      mt: 1,
                      mr: 1,
                      color: "white !important",
                      "&:hover, :focus": {
                        color: `${theme.palette.primary.contrastColor} !important`,
                        backgroundColor: `${theme.palette.success.dark} !important`,
                      },
                    }}
                  >
                    {index === answers.length - 1 ? "Finish" : "Continue"}
                  </Button>
                )}
                <Button
                  variant={
                    answer.node_type !== "leaf" && answer.a_type !== "mc"
                      ? "text"
                      : "contained"
                  }
                  disabled={index === 0}
                  onClick={handleBack}
                  sx={{ mt: 1, mr: 1 }}
                >
                  Back
                </Button>
              </div>
            </Box>
          </>
        );
        break;
      case "authenticator":
        answerOptionsUI = (
          <>
            <Box
              sx={{
                width: "77%",
                [theme.breakpoints.down("md")]: {
                  width: "100%",
                },
              }}
            >
              <Authenticator showTitle={false} />
            </Box>

            <Box sx={{ mb: 2 }}>
              <div>
                <Button
                  disabled={index === 0}
                  onClick={handleBack}
                  sx={{ mt: 1, mr: 1 }}
                >
                  Back
                </Button>
              </div>
            </Box>
          </>
        );
        break;
      default:
    }

    return <Container>{answerOptionsUI}</Container>;
  };

  const finalizeSelectedLoanAndRedirect = () => {
    // // NOTE selectedLoan starts in the UI here
    // then on BE it populated further with additional stats
    //
    let updatedSelectedLoan = Object.assign({}, selectedLoan);

    if (leadRef && !selectedLoan.leadRef) {
      updatedSelectedLoan.leadRef = leadRef;
    }

    const phoneNumber = answers.filter((answer) => {
      return answer.q_title === "Phone";
    })?.[0]?.a_string;
    const firstName = answers.filter((answer) => {
      return answer.q_title === "First name";
    })?.[0]?.a_string;
    const lastName = answers.filter((answer) => {
      return answer.q_title === "Last name";
    })?.[0]?.a_string;

    const finalPhoneNumber = userProfile?.PhoneNumber
      ? userProfile?.PhoneNumber
      : phoneNumber;

    const finalFirstName = userProfile?.FirstName
      ? userProfile?.FirstName
      : firstName;

    const finalLastName = userProfile?.LastName
      ? userProfile?.LastName
      : lastName;

    // answers
    (async () => {
      // first make sure UID is set for the loan
      // so its protected. UID is set for logged in users
      // already, but need to do it one more time here in case
      // user just signed in, like a new user

      let updatedCurrentLoan = await updateLoan2(user, currentLoan.id, {
        UID: user.uid,
      });

      // Special logic for refi-> rate term and cash out

      const loanPurpose = answers.filter((answer) => {
        return answer.q_title === "Loan purpose";
      })?.[0]?.a_string;
      let updatedAnswers = answers.slice();
      if (loanPurpose === "Refinance") {
        const refinanceType = answers.filter((answer) => {
          return answer.q_title === "Refinance type";
        })?.[0]?.a_string;

        const existingDebt = answers.filter((answer) => {
          return answer.q_title === "Existing debt";
        })?.[0]?.a_string;

        const purchaseDate = answers.filter((answer) => {
          return answer.q_title === "Purchase date";
        })?.[0]?.a_string;
        const purchaseDateObj = new Date(purchaseDate);
        const today = new Date();

        if (refinanceType === "Rate term refinance") {
          // IF "Rate term refinance" is selected
          // AND Existing debt is 0
          // AND Purchase date is in the future
          // THEN switch request to "Purchase"

          if (existingDebt === "0" && purchaseDateObj > today) {
            const targetAnswer = updatedAnswers.filter((updatedAnswer) => {
              return updatedAnswer.q_title === "Loan purpose";
            })[0];
            targetAnswer.a_string = "Purchase";
          }
          // IF "Rate term refinance" is selected
          // AND Existing debt is 0
          // AND Purchase date is in the past
          // THEN switch request to "Cash out refinance"

          if (existingDebt === "0" && purchaseDateObj < today) {
            const targetAnswer = updatedAnswers.filter((updatedAnswer) => {
              return updatedAnswer.q_title === "Refinance type";
            })[0];
            targetAnswer.a_string = "Cash out refinance";
          }
        }
      }

      // now that UID is part of the loan for sure
      // many other deeper updates can take place on BE

      updatedCurrentLoan = await updateLoan(
        user,
        updatedAnswers,
        false, // dont set current loan here, will trigger re-renders that we dont need
        currentLoan,
        loanQuoteData,
        updatedSelectedLoan,
        {
          FirstName: finalFirstName,
          LastName: finalLastName,
          PhoneNumber: finalPhoneNumber,
          Email: user.email,
          UID: user.uid,
          Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            ? Intl.DateTimeFormat().resolvedOptions().timeZone
            : "UTC",
        },
        "submitted", // loan status on creation is set here,
        null, // loanSectionController
        DSCRCalculatorQuestions // send most recent dscr calculator questions to create initial calc for loan terms
      );

      gtag.event({ action: "finish_quote" });

      // no more FB ads, didn't perform well
      // keeping in case we give it attempts again in the future

      // await newLoanQuoteSlackNotification(updatedCurrentLoan); // move this to BE
      // await triggerLoanUpdateEmail(user, updatedCurrentLoan, "welcome");

      // welcome loan is sent by a less protected endpoint hence why mechanism and functions are different from triggerLoanUpdateEmail
      // clean up
      setCurrentLoan({});
      setSelectedLoan({});
      setLoanQuoteData({});
      setAnswers({});
      // then go to my/loans
      router.push("/my/loans?loan_quote_submitted=true");
    })();
  };

  return (
    <Box>
      <Stepper
        color={"secondary"}
        nonLinear
        activeStep={activeStep}
        orientation="vertical"
      >
        {answers.length > 0
          ? answers.map((answer, index) => (
              <Step
                id={
                  scrollID
                    ? `${scrollID}_question_${index}`
                    : `question_${index}`
                }
                key={`${answer.q_title}_${index}`}
                sx={{
                  display:
                    answer.node_visibility !== "hidden" ? "block" : "none",
                }}
              >
                <StepButton
                  icon={<RemoveSharpIcon />}
                  key={`${answer.q_title}_${index}_stepButton`}
                  sx={{
                    "& .MuiStepLabel-label": {
                      fontSize: theme.spacing(3),
                    },
                    "& .MuiStepIcon-root.Mui-active": {
                      fill: theme.palette.secondary.main,
                    },
                  }}
                  color="inherit"
                  onClick={() => {
                    handleStep(index);
                  }}
                >
                  {answer.q_title}
                </StepButton>
                <StepContent>
                  <Typography>
                    {answer.q_description(answer, answers)}
                  </Typography>
                  {generateAnswerOptions(answer, index, answers, activeStep)}
                </StepContent>
              </Step>
            ))
          : [
              "Loan type",
              "Investment experience",
              "Credit score",
              "Borrowing entity",
              "Loan purpose",
              "Purchase price",
              "Estimated AS-IS value",
              "After repair value (ARV)",
            ].map((skeletonTitle, index) => {
              return (
                <Step
                  id={
                    scrollID
                      ? `${scrollID}_question_${index}`
                      : `question_${index}`
                  }
                  key={`${index}_skeleton_step`}
                  sx={{
                    display: "block",
                  }}
                >
                  <StepButton
                    icon={<RemoveSharpIcon />}
                    key={`${index}_stepButton_skeleton`}
                    sx={{
                      "& .MuiStepLabel-label": {
                        fontSize: theme.spacing(3),
                      },
                      "& .MuiStepIcon-root.Mui-active": {
                        fill: theme.palette.secondary.main,
                      },
                    }}
                    color="inherit"
                    // onClick={() => {
                    // }}
                  >
                    {skeletonTitle}
                  </StepButton>
                  <StepContent>
                    <Skeleton
                      sx={{ width: "100%", margin: theme.spacing(2, 0) }}
                      animation="wave"
                      variant="rounded"
                      height={theme.spacing(5)}
                    />
                    <Skeleton
                      sx={{ width: "100%", margin: theme.spacing(2, 0) }}
                      animation="wave"
                      variant="rounded"
                      height={theme.spacing(5)}
                    />
                    <Skeleton
                      sx={{ width: "100%", margin: theme.spacing(2, 0) }}
                      animation="wave"
                      variant="rounded"
                      height={theme.spacing(5)}
                    />
                  </StepContent>
                </Step>
              );
            })}
      </Stepper>
      {activeStep === answers.length && (
        <Paper square elevation={0} sx={{ p: 3 }}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleBack} sx={{ mt: 1, mr: 1 }}>
            Back
          </Button>
          <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
            Reset
          </Button>
        </Paper>
      )}
    </Box>
  );
}

export default QuoteStepper;
